import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { AppService, UserService } from 'briteatlib';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { CURRENT_BUSINESS_ID } from '../services/shared.service';
import { Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';

let redirectingToLogin = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const appService = inject(AppService);
  const router = inject(Router);
  const auth = inject(Auth);

  return from(userService.getToken()).pipe(
    switchMap(token => {
      var headers: { [name: string]: string | string[] } = {};
      // clientId is derived from localStorage and is undefined during SSR. Setting a header
      // to an undefined value makes HttpHeaders throw, which would abort every SSR request,
      // so only set it when present.
      if (appService.clientId) headers['X-BRT-Client-Id'] = appService.clientId;
      if (token) headers['Authorization'] = `Bearer ${token}`;
      // localStorage is browser-only; guard it so this interceptor doesn't throw on every
      // HTTP request during server-side rendering (which would abort SSR data fetching).
      var businessId = typeof localStorage !== 'undefined' ? localStorage.getItem(CURRENT_BUSINESS_ID) : null;
      if (businessId) headers['X-BRT-Business-Id'] = businessId;
      if(appService.pos) headers['X-BRT-POS'] = 'true';
      // if (location.search.includes('apikey'))
      //   headers['X-BRT-Api-Key'] = location.search.split('apikey=')[1].split('&')[0];
      req = req.clone({ setHeaders: headers });
      return next(req).pipe(
        catchError(error => {
          // The BritLink panel has its own login UI and business-selection flow.
          // Before a business is selected its background polling (next print job,
          // pending count, heartbeat) legitimately returns 401, so a global
          // sign-out + redirect here would log the just-authenticated user back
          // out and bounce them to the consumer /login page — an endless loop.
          const inBritlinkPanel =
            (typeof window !== 'undefined' && window.location?.pathname?.startsWith('/britlink')) ||
            router.url?.startsWith('/britlink') ||
            req.url.includes('/api/britlink/');
          if (
            error instanceof HttpErrorResponse &&
            error.status === 401 &&
            typeof window !== 'undefined' &&
            !inBritlinkPanel &&
            !redirectingToLogin
          ) {
            redirectingToLogin = true;
            const redirectTo = router.url && router.url !== '/login' ? router.url : undefined;
            auth.signOut()
              .finally(() => router.navigate(['/login'], { queryParams: redirectTo ? { redirectTo } : undefined }))
              .finally(() => redirectingToLogin = false);
          }
          return throwError(() => error);
        })
      );
    })
  );
};
